<template>
  <section class="sal-card">
    <div class="sal-section-head">
      <h1 class="sal-section-title">Datos de Registro</h1>
    </div>

    <SALDateField
      v-model="localForm.fecha"
      id="sal-fecha"
      label="Fecha de Reporte"
      placeholder="DD/MM/AAAA"
      :error="errors.fecha"
      error-message="Captura la fecha en formato día/mes/año."
      @update:modelValue="notifyFieldChange('fecha')"
    />

    <SALDropdown
      v-model="localForm.operador"
      label="Operador"
      placeholder="Nombre del operador"
      :options="operadores"
      :error="errors.operador"
      error-message="Selecciona un operador."
      @select="handleOperadorSelect"
    />
  </section>
</template>

<script setup>
import { computed } from "vue";

import SALDateField from "../components/SALDateField.vue";
import SALDropdown from "../components/SALDropdown.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  operadores: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function handleOperadorSelect(option) {
  localForm.value.operadorLabel = option.label;
  notifyFieldChange("operador");
}

function notifyFieldChange(field) {
  emit("field-change", { field });
}
</script>
